import { createActions } from 'redux-actions';
import types from './types';

const { setUser, clearUser } = createActions(types.SET_USER, types.CLEAR_USER);

export default { setUser, clearUser };



// WEBPACK FOOTER //
// ./src/reducers/user/actions.js